module.exports = __webpack_public_path__ + "media/svg/link-ia-6385d41b.svg";